export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  as = 'button',
  ...props
}) {
  const baseClass = 'button';
  const variantClass = `button-${variant}`;
  const Element = as;

  return (
    <Element
      className={`${baseClass} ${variantClass} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </Element>
  );
}
